<div>
    <kendo-gridlayout [rows]="[{height:38}]"
                      [cols]="[{width:100},{width:240}]"
                      [gap]="{cols: 10}">

        <kendo-gridlayout-item [row]="1" [col]="1" [colSpan]="1">
            <kendo-numerictextbox id="{{ control.id }}" [decimals]="toNumeric(control).decimals" [format]="toNumeric(control).format" [(ngModel)]="toNumeric(control).value"></kendo-numerictextbox>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item [row]="1" [col]="2" [colSpan]="1">
            <app-select-field [control]="currencySelect" (onChange)="currencyOnChange($event)"></app-select-field>
        </kendo-gridlayout-item>

    </kendo-gridlayout>
</div>
